 
<template>
  <popup ref="popup" :appendToBody="true">
    <div slot="body" class="body">
      <div class="search">
        <el-form ref="form" :model="searchParams" class="form">
          <el-row>
            <el-col :span="24" class="name">
              <el-form-item
                label="高校名称："
                label-width="100px"
                class="nameinput"
              >
                {{parameter.name}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="operator">
        <el-button
          type="primary"
          @click="toSave()"
          v-has-permission-code-and="'1000000000250005'"
          >添加
        </el-button>
      </div>
  
      <div v-if="listData">
        <el-table
          class="table"
          :data="listData.records"
          max-height="380"
          @selection-change="selectionChange"
          v-loading="listLoading"
          :header-cell-style="{ background: '#F3F4F7', color: '#686D72' }"
        >
          <el-table-column
            type="selection"
            width="55"
            fixed="left"
          ></el-table-column>

              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="post" label="职位"></el-table-column>
              <el-table-column prop="state" label="在职情况">
                     <template slot-scope="scope" >
                        <el-tag type="success" v-if="scope.row.state == 1">在职</el-tag>
                        <el-tag type="danger" v-if="scope.row.state == 0">已离职</el-tag>
            </template>

              </el-table-column>
              <el-table-column prop="sex" label="性别"></el-table-column>
              <el-table-column prop="mobile" label="电话"></el-table-column>
              

        
          <el-table-column
            label="操作"
            fixed="right"
            width="280"
            align="center"
          >
            <!-- 对状态进行操作 -->
                  <template slot-scope="scope">
                  <div class="dataTable-operator">
                    <el-button
                      v-has-permission-code-and="'1000000000250000'"
                      size="mini"
                      icon="el-icon-search"
                      @click="toDetail(scope.$index, scope.row)"
                      >详情</el-button
                    >
                    <el-button
                      v-has-permission-code-and="'1000000000250005'"
                      size="mini"
                      icon="el-icon-edit"
                      @click="toUpdate(scope.$index, scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      v-has-permission-code-and="'1000000000250005'"
                      size="mini"
                      icon="el-icon-delete"
                      type="danger"
                      @click="remove(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </div>
                </template>
          </el-table-column>
        </el-table>
        <div
          class="pageBar"
          style="margin: 20px auto; display: flex; justify-content: center"
        >
          <el-pagination
            @size-change="sizeChange"
            @current-change="currentChange"
            :total="listData.total"
            :page-size="page.size"
            :current-page="page.current"
            :layout="this.$constant.page.layout"
            :page-sizes="this.$constant.page.pageSizes"
          ></el-pagination>
        </div>
      </div>
      <edit ref="edit" @flush="list()" ></edit>
    </div>
    <div slot="footer">
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import edit from "./edit.vue";
import api from "@/api/consu/collegesteacher/collegesteacher.js";

export default {
  name: "collegesteacher",
  components: {
    edit,
    popup,
  },
  data() {
    return {
      disabled: false,
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      parameter: {},
      page: new this.$constant.pageObj(),
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, size) {
            console.log( parameter)
      //高校信息
      this.parameter = parameter;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.list();
      });
    },
    //获取数据
    list() {
      this.listLoading = true;
      
      this.searchParams.cid = this.parameter.id;
      let params = this.$utils.merger(this.searchParams, this.page);
      api.list(params, (response) => {
        this.listData = response.data;
        this.listLoading = false;
      });
    }, //关闭弹框
    close() {
      this.$refs.popup.close();
    },
    //去添加
    toSave() {
      this.$refs.edit.open({cid: this.parameter.id}, "添加");
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id,
      };
      this.$refs.edit.open(editParameter, "编辑");
    },
    //去详情
    toDetail(index, row) {
      let detailParameter = {
        id: row.id,
      };
      this.$refs.edit.open(detailParameter, "详情", true);
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.body {
  background-color: #f7f7f7;
  .search {
    padding: 10px 20px;
    box-sizing: border-box;
    .form {
      .name {
        display: flex;
        .nameinput {
          width: 400px;
        }

         .looklist {
          margin-left: 20px;
          height: 40px;
        }
      }

    }
  }

  .lookdata {
    font-size: 13px;
    padding: 0 20px;
  }
  .operator{
    padding: 10px 20px;
    margin: 0;
  }
  .alert{
    padding: 0 0 10px 0;
  }

}
.link-f{
  .link{
    display: flex;
    justify-content: center;
  }
}
.table{
  font-size: 13px;
}
.drawer-body{
  background-color: #f7f7f7;
}


</style>